import { compare } from 'compare-versions';

// Read synchronously rather than via useQuery — a synchronous queryFn drives a re-render loop on
// react-query 5.101 (issue #1027). localStorage is the source of truth and the read is cheap.
export const useIosAppVersion = (): string | null => localStorage.getItem('ios_app_version');

export const useFeatureOnIos = (featureVersion: string) => {
  const appVersion = useIosAppVersion();

  if (window.webkit && !appVersion) {
    // If we are on ios and we don't have a version storet, we assume we are on an older version that is not supported
    return false;
  }

  if (!appVersion) {
    // For clients that are not in the ipad app we don't have a version number, and for those we should allow all these features.
    return true;
  }

  return compare(appVersion, featureVersion, '>=');
};
